<template>
  <div>
    <div class="handle-wrapper">
      <Button @click="$router.push('/home/sac')">返回</Button>
      <h1>{{sacDetail.name}}</h1>
      <!-- <Input v-model="searchText" search placeholder="搜索原材料..." @on-enter="searchSac" style="width: 250px; margin-right: auto;">
				<Button slot="append" icon="ios-search" @click="searchSac"></Button>
			</Input>
			<span>共{{totalRows}}条</span>
			<Page :total="totalRows" :page-size="15" @on-change="loadSac" show-total simple style="margin-right: 24px"/>
      <Button type="primary" @click="$refs.EditSACDrawer.openDrawer()">新增车辆</Button>-->
    </div>
    <Tabs :value="currentTab" :animated="false" type="card">
      <TabPane label="生产订单" name="prodOrder">生产订单</TabPane>
      <TabPane label="客户与配方" name="customer">
        <SACDetailCustomer
          ref="SACDetail_Customer"
          :sac="sacDetail"
          @updateSacFromComponent="updateSacFromComponent"
        />
      </TabPane>
      <TabPane label="材料" name="material">
        <SACDetailMaterial
          ref="SACDetail_Material"
          :sac="sacDetail"
          @updateSacFromComponent="updateSacFromComponent"
        />
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import EditSACDrawer from "./EditSACDrawer.vue";
import SACDetailCustomer from "./SACDetail_Customer.vue";
import SACDetailMaterial from "./SACDetail_Material.vue";

export default {
  name: "SacDetail",
  components: { EditSACDrawer, SACDetailCustomer, SACDetailMaterial },
  data() {
    return {
      page: 0,
      searchText: "",
      currentTab: "customer",
      materialLoading: false,
      materialColumns: [
        {
          title: "名字",
          key: "name",
          width: 150,
        },
        {
          title: "型号",
          key: "model",
          width: 100,
        },
        {
          title: "类型",
          key: "type",
          width: 100,
        },
        {
          title: "操作",
          key: "action",
          width: 60,
        },
      ],
      materialTableData: [],
      columns: [
        {
          title: "ID",
          key: "NoId",
          width: 100,
          render: (h, params) => h("span", params.row.NoId),
        },
        {
          title: "名字",
          key: "name",
          // width: 130,
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    color: "#42b983",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.EditSACDrawer.openDrawer(params.row);
                    },
                  },
                },
                "SAC"
              ),
            ]);
          },
        },
      ],
    };
  },
  computed: {
    ...mapState({
      sacDetail: (state) => state.sac.sac,
    }),
  },
  methods: {
    ...mapActions({
      getSacById: "sac/getSacByIdAction",
    }),
    async loadSacDetail() {
      const sacId = this.$route.params.id;
      if (sacId === undefined) return this.$router.push("/sac");
      this.getSacById(sacId);
    },
    addMaterial() {},
    updateSacFromComponent() {
      this.getSacById(this.$route.params.id);
    },
  },
  created() {
    this.loadSacDetail();
    if (["material", "customer"].includes(this.$route.hash.substring(1))) {
      this.currentTab = this.$route.hash.substring(1);
    }
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center

  h1
    margin-left 15px

.table-wrapper
  width 100%
  height calc(100% - 48px)
  display flex

.m-area
  width 500px
  padding 0 12px

.c-area
  width 400px
  padding 0 12px
</style>
